//const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
  mode: 'jit',
  content: ['./src/**/*{html,.js,.jsx}'],
  important: 'body #appRoot',
  theme: {
    container: {
      center: true,
      padding: {
        DEFAULT: '1.5rem',
        sm: '1.5rem',
        md: '1.75rem',
        lg: '2rem',
        xl: '3rem'
      }
    },
    fontFamily: {
      sans: [
        'Helvetica Neue',
        'sans-serif',
        'system-ui',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Roboto'
      ],
      times: ['Times Now', 'sans-serif']
    },
    fontSize: {
      '2xs': ['9px', '11px'],
      xs: ['11px', '14px'],
      sm: ['12px', '14px'],
      base: ['14px', '14px'],
      md: ['16px', '19px'],
      lg: ['18px', '19px'],
      xl: ['20px', '25px'],
      '2xl': ['24px', '29px'],
      '4xl': ['28px', '33px'],
      '6xl': ['32px', '37px'],
      '7xl': ['40px', '64px'],
      '75xl': ['52px', '1'],
      '8xl': ['60px', '64px'],
      '9xl': ['8rem', '1'],
      '10xl': ['10rem', '1'],
      arrow: ['36px', '41px']
    },
    fontWeight: {
      thin: '200',
      light: '300',
      base: '400',
      normal: '500',
      semibold: '600',
      bold: '700',
      extrabold: '900'
    },
    borderWidth: {
      DEFAULT: '1px',
      0: '0',
      1.5: '1.5px',
      2: '2px',
      3: '3px',
      4: '4px',
      6: '6px',
      8: '8px'
    },
    extend: {
      transitionDuration: {
        400: '400ms'
      },
      colors: {
        product: '#E6E6E6',
        heroarrows: '#777777',
        creativeFeatureSlider: '#F8F7F7',
        blackFriday1: '#ECECEC',
        blackFriday2: '#F8F8F8',
        purplePromo: '#6E80D0'
      },
      animation: {
        fade: 'fadeIn .2s ease-in-out',
        'pulse-scale': 'pulse-scale 0.7s ease-in-out infinite',
        shimmer: 'shimmer 1.5s linear infinite',
        flash: 'flash 0.8s ease-in-out infinite',
        'flash-scale': 'flash-scale 1.2s ease-in-out infinite',
        'appear-in-out': 'appear-in-out 4s linear infinite',
        fadeIn: 'fadeIn 0.4s',
        fadeOut: 'fadeOut 0.4s'
      },
      keyframes: (theme) => ({
        fadeIn: {
          from: { opacity: 0 },
          to: { opacity: 1 }
        },
        fadeOut: {
          from: { opacity: 1 },
          to: { opacity: 0 }
        },
        'pulse-scale': {
          '0%, 100%': { transform: 'scale(1)' },
          '30%': { transform: 'scale(1.15)' },
          '60%': { transform: 'scale(0.97)' }
        },
        shimmer: {
          '0%': { backgroundPosition: '-200% 0' },
          '100%': { backgroundPosition: '200% 0' }
        },
        flash: {
          '0%, 100%': { color: 'inherit' },
          '50%': { color: '#facc15' }
        },
        'flash-scale': {
          '0%, 100%': { color: 'inherit', transform: 'scale(1)' },
          '50%': { color: '#FFFFFF', transform: 'scale(1.25)' }
        },
        'appear-in-out': {
          '0%, 29%, 71%': { opacity: 1 },
          '30%, 70%': { opacity: 0 }
        }
      }),
      fontFamily: {
        body: ['Thasadith']
      }
    }
  },
  plugins: [
    require('@tailwindcss/aspect-ratio'),
    require('tailwind-scrollbar-hide')
  ]
};
